import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheComuniApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useComuniDataSource(nazioneId: string | undefined, regioneId: string | undefined, provinciaId: string | undefined) {
  const api = new AnagraficheComuniApi(apiConfiguration);

  const dataSource = useMemo(() => {
    return new CustomStore({
      key: "id",
      loadMode: 'raw',
      load: (loadOptions) => {
        if (nazioneId && regioneId && provinciaId)
          return api.getComuni({ nazioneId: nazioneId, regioneId: regioneId, provinciaId: provinciaId });
        else
          return [];
      },
      byKey: (key) => {
        return api.getComuneById({
          comuneId: key
        });
      }
    });
  }, [nazioneId, regioneId, provinciaId]);

  return dataSource;
}


